export const BUSINESS = "Arrow Locksmith";
export const PHONE_DISPLAY = "(204) 963-9081";
export const PHONE_TEL = "tel:+12049639081";
export const PHONE_SMS = "sms:+12049639081";
export const AREAS = [
  "Downtown",
  "St. Boniface",
  "Transcona",
  "St. Vital",
  "Fort Garry",
  "St. James",
  "River Heights",
  "Tuxedo",
  "North Kildonan",
  "East Kildonan",
  "West Kildonan",
  "Fort Rouge",
  "Charleswood",
  "Headingley",
];
